import { Response, httpGet, httpPost } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {};

const fetchAccountLink = createAsyncThunk(
  "stripe/fetch account link",
  async () => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPost(`${REACT_APP_BASE_URL}/api/v1/stripe/account/link`, {}, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const createAccount = createAsyncThunk(
  "stripe/Creates an account on stripe and returns the account id",
  async () => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPost(`${REACT_APP_BASE_URL}/api/v1/stripe/account/`, {}, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const userHasStripeAccount = createAsyncThunk(
  "stripe/Fetches if there is an existing stripe account",
  async () => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(`${REACT_APP_BASE_URL}/api/v1/stripe/account/`, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const getIntentDetails = createAsyncThunk(
  "stripe/get intents detail",
  async (id: string) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(
          `${REACT_APP_BASE_URL}/api/v1/stripe/payment/intents/${id}`,
          true
        )
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const transactionsSlice = createSlice({
  name: "transactions",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const transactionsReducer = transactionsSlice.reducer;

export const transactionsActions = {
  ...transactionsSlice.actions,
  fetchAccountLink,
  createAccount,
  userHasStripeAccount,
  getIntentDetails,
};
